var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.232 11.86C12.1364 11.848 12.0396 11.848 11.944 11.86C10.9263 11.8258 9.96184 11.3973 9.25426 10.665C8.54667 9.93283 8.15142 8.95424 8.152 7.93601C8.152 5.76401 9.904 4.00001 12.088 4.00001C13.1193 3.99822 14.1101 4.40178 14.8466 5.12369C15.5831 5.8456 16.0065 6.82803 16.0254 7.85919C16.0443 8.89035 15.6572 9.88763 14.9476 10.636C14.238 11.3844 13.2627 11.824 12.232 11.86V11.86ZM20.176 19.78C17.9707 21.8069 15.0832 22.9293 12.088 22.924C8.968 22.924 6.136 21.736 4 19.78C4.12 18.652 4.84 17.548 6.124 16.684C9.412 14.5 14.788 14.5 18.052 16.684C19.336 17.548 20.056 18.652 20.176 19.78V19.78Z",
    fill: "#251351",
    stroke: "#251351",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 12C23.25 18.2134 18.2134 23.25 12 23.25C5.78661 23.25 0.75 18.2134 0.75 12C0.75 5.78661 5.78661 0.75 12 0.75C18.2134 0.75 23.25 5.78661 23.25 12Z",
    stroke: "#251351",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.eb90c4ad4f3acca1338e05f0ea286e97.svg";
export { ForwardRef as ReactComponent };